import { AppSettingsModule } from 'services/settings.provider';
import { FounderGuideServiceModule } from 'services/utilities/founderGuide.service';
import { StorefrontCacheServiceModule } from 'services/utilities/storefrontCache.service';
import { DataServiceModule } from './data.service';

export const PagesServiceModule = angular
    .module('app.services.data.pagesService', [
        DataServiceModule,
        AppSettingsModule,
        FounderGuideServiceModule,
        StorefrontCacheServiceModule
    ]).service('pagesService', (
        $window,
        dataService,
        founderGuideService,
        storefrontCacheService,
        settings
    ) => {
        const PAGE_STATE = {
            active: 'Active',
            inactive: 'Inactive'
        };
        const QUERY = {
            active: 'isActive eq true',
            inactive: 'isActive eq false',
            defaultSort: ['updatedOn+desc']
        };
        return {
            PAGE_SIZE: 25,
            START_PAGE: 1,
            QUERY,
            save,
            create,
            removePage,
            getMetrics,
            getPage,
            getPages,
            getPageCount,
            copyPage,
            refreshStorefrontCache,
            buildFilter
        };

        function save(page) {
            return dataService.save(settings.api.pages, page.id, page)
                .then((result) => {
                    this.refreshStorefrontCache();
                    return result;
                });
        }

        function create(page, completeTask = true) {
            return dataService.create(settings.api.pages, page).then((data) => {
                const taskId = 'organize.addPage';
                const firstPageCreated = 'pagesService:firstPageCreated';
                const MILESTONE = 3;
                const FOUNDERGUIDE_STEP_KEY = 'pageDetails:founderGuideStepComplete';

                if (completeTask) {
                    return founderGuideService.completeFounderGuideTask(taskId, firstPageCreated, MILESTONE)
                        .then((taskCompleted) => {
                            if (taskCompleted) $window.sessionStorage.setItem(FOUNDERGUIDE_STEP_KEY, true);
                            return data;
                        });
                }

                this.refreshStorefrontCache();
                return data;
            });
        }

        function removePage(page) {
            return dataService.remove(settings.api.pages, page.id)
                .then((result) => {
                    this.refreshStorefrontCache();
                    return result;
                });
        }

        function getPage(id) {
            return dataService.get(settings.api.pages, id);
        }

        function getPages(page, sort, options) {
            options = options || {};
            if (sort && sort.length) {
                options.sortBy = sort[0].replace(' ', '+');
            }
            return dataService.getAll(settings.api.pages, options);
        }

        function getMetrics() {
            return dataService.getAll(settings.api.pagesMetrics, {});
        }

        function getPageCount() {
            return dataService.getAll(settings.api.pages, {
                sortBy: QUERY.defaultSort,
                pageSize: 1
            }).then(response => response.total);
        }

        function copyPage(item, nameLength) {
            let copyItem = angular.copy(item);
            copyItem.seo.friendlyName = null;
            copyItem.id = '';
            return dataService.copy(settings.api.pages, copyItem, nameLength)
                .then((result) => {
                    this.refreshStorefrontCache();
                    return result;
                });
        }

        function refreshStorefrontCache() {
            return storefrontCacheService.refresh('content');
        }

        function buildFilter(filterQuery) {
            switch (filterQuery) {
                case PAGE_STATE.active:
                    return QUERY.active;
                case PAGE_STATE.inactive:
                    return QUERY.inactive;
                default:
                    return null;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/pages.service.js